import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cortex = defineConnector({
  identifier: "cortex",
  name: "Cortex",
  tagLine: "Security analysis and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `${host.replace(/\./g, "\\.").replace(/\//g, "\\/")}/.*`
      : "https://.*",
  auth: (app) => bearerAuth(app.secret.cortexApiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Cortex instance, navigate to **Organization → Users** and generate an API key for your user account.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "url",
          label: "Cortex host",
          required: true,
          placeholder: "https://cortex.example.com",
          target: { kind: "configuration", field: "host" },
          helperText: "The base URL of your Cortex instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "cortexApiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `${host}/api/analyzer`,
  },
});
